<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera fördelningen för pausreklam</h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
    <dot-loader [visibility]="show.updatingEstimates"></dot-loader>
  }
  <div class="container">
    <div class="left-item">
        @if (show.isEditing) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="pauseAdValues.invalid"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button primary"
            (click)="setEditing(true)"
          >
            Redigera Paus-värden
          </button>
        }
    </div>
    <div class="right-item">
      @if (productFormats?.length > 1) {
        <div class="dropdown filter-dropdown margin-left--2x">
          <woo-dropdown
            [items]="productFormats"
            [(ngModel)]="selectedProductFormat"
            name="selectedProductFormat"
            inputId="select-product-format"
            labelText="Filtrera på Placering"
            [labelTransform]="translateProductFormat"
            notFoundText="Inga Placeringar hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>
      }

      @if (publishers?.length > 1) {
        <div class="dropdown filter-dropdown margin-left--2x">
          <woo-dropdown
            [items]="publishers"
            [(ngModel)]="selectedPublisher"
            name="selectedPublisher"
            inputId="select-publisher"
            labelText="Filtrera på Publicist"
            notFoundText="Inga publicister hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>
      }
    </div>
  </div>
  <div class="sticky-header">
    <h3>Fördelning av pausreklam</h3>
  </div>



  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #pauseAdValues="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="1">Estimatfördelning</th>
        <th class="text-center" colspan="1">Maxuttag</th>
      </tr>
      <tr>
        @for (header of tableHeaders; track header) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (
        row of pauseAdRows;
        let index = $index;
        track index
      ) {
        <tr [hidden]="!rowVisible(row)">
          <td class="text--thin vertical-align--middle">
            <span>{{ row.publisher }}</span>
          </td>
          <td class="text--thin vertical-align--middle">
            <span>{{ translateProductFormat(row.productFormat) }}</span>
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.pauseAdShare | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPauseAdShare"
                  [(ngModel)]="getProductFormat(row.productFormatId).pause_ad_share"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="true"
                />
              </div>
            }
          </td>

          <td class="vertical-align--middle">
            @if (!show.isEditing) {
              <span>{{ row.pausAdWithdrawalLimit | percent: '1.0-3' }}</span>
            } @else {
              <div class="input__container">
                <input
                  name="row-{{ index }}-sharesPreroll"
                  [(ngModel)]="getProductFormat(row.productFormatId).pause_ad_withdrawal_limit"
                  wooPercentFormatter
                  [wooMinValidator]="0"
                  [wooMaxValidator]="1"
                  [required]="true"
                />
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="pauseAdValues.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
</div>